import ProjectsGrid from '../../components/ProjectsGrid/ProjectsGrid';
import { projects } from '../../siteData/Projects';
import SEO from '../../components/SEO/SEO';

const Products = () => {
  return (
    <>
      <SEO
        title='Commercial Product Photography in Bangalore'
        description='High-end commercial studio product photography of lifestyle products like watch, jewellery, skin care products, IOT brands like  Titan, Fastrack, Atomz Energy,Mamaearth, Noise, Plum Skin.'
        keywords='food photography Bangalore, product photography Bangalore, commercial photography studio, food videography Bangalore, product videography services, ad film production Bangalore'
        url='https://mudrost.in/product'
        itempropDescription='Mudrost Studio – Bangalore’s top creative studio for food photography, product photography, and high-end brand videography.'
      />
      <ProjectsGrid projects={projects} category={'products'} />
    </>
  );
};

export default Products;
